import { render, staticRenderFns } from "./CompanySetup.vue?vue&type=template&id=f9a01316&scoped=true"
import script from "./CompanySetup.vue?vue&type=script&lang=js"
export * from "./CompanySetup.vue?vue&type=script&lang=js"
import style0 from "./CompanySetup.vue?vue&type=style&index=0&id=f9a01316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a01316",
  null
  
)

export default component.exports